<template>
  <div v-if="articles.length" class="related-articles">
    <p class="h4">
      Related Articles
    </p>
    <ul>
      <li v-for="({ slug, title }, idx) in articles" :key="idx">
        <nuxt-link :to="`/support/${slug}/`">
          {{ title }}
        </nuxt-link>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    articles: { type: Array, default: () => ([]) },
  },
};
</script>

<style scoped lang="scss">
.related-articles {
  background-color: var(--main-light);
  padding: var(--spacing-40) var(--spacing-100);
  margin-top: var(--spacing-16);
  border-radius: 10px;
  border: 1px solid var(--main-light-shade-3);

  .h4 {
    font-size: 18px;
    font-weight: 500;
    margin: 0 0 var(--spacing-16);
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      padding: 0;

      &:not(:last-child) {
        margin-bottom: var(--spacing-16);
      }

      a {
        color: var(--accent-shade-2);
        font-size: 14px;
        font-weight: 400;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  @include bp($bp-phone) {
    padding: 30px var(--spacing-36);
  }
}
</style>
